module.exports = __webpack_public_path__ + "img/66.abda82e5.png";